// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3NE_2","label":"CategoryService_label__tIl1T","location":"CategoryService_location__Ggncv"};